export default {
  label: {
    time: 'tìm kiếm theo thời gian',
    orderNo: 'tìm kiếm theo mã giao dịch',
    amount: 'số tiền',
    channelCode: 'mã code loại thanh toán',
    channelType: 'loại thanh toán',
    createAcct: 'người tạo tài khoản',
    createTime: 'thời gian tạo',
    id: 'mã chính ID',
    merchantNo: 'Tài khoản merchant',
    merchantOrderNo: '	mã giao dịch merchant',
    status: '	trạng thái giao dịch',
    systemOrderNo: 'số hệ thống',
    BeginTime: 'thời gian bắt đầu và kết thúc',
    serviceType: 'Loại dịch vụ',

    accountNumber: 'Tài khoản nhận',
    currency: 'loại tiền tệ	',
    extra: 'thông số bổ sung	',
    message: 'trạng thái giao dịch	',
    notifyUrl: 'địa chỉ callback	',
    remark: 'Nhận xét',
    sign: 'chữ ký	',
    updateAcct: 'người cập nhật',
    updateTime: 'thời gian cập nhật',
    userIP: 'IP'
  },
  rules: {
    amount: 'số tiền không được để trống',
    channelCode: 'mã kênh không được để trống',
    channelType: 'loại thanh toán bắt buộc chọn',
    createAcct: 'người tạo tài khoản không được để trống',
    createTime: 'thời gian không được bỏ trống',
    id: 'mã chính ID không được bỏ trống',
    merchantNo: 'tài khoản merchant không được bỏ trống',
    merchantOrderNo: '	mã giao dịch không được bỏ trống',
    status: '	trạng thái giao dịch bắt buộc chọn',
    systemOrderNo: 'số hệ thống không được để trống',
    BeginTime: 'thời gian bắt buộc chọn',
    serviceType: 'Loại dịch vụ bắt buộc chọn'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/transaction.js